// extracted by mini-css-extract-plugin
module.exports = {"mobileFixedHeaderWrapper":"MobileFixedHeaderWrapper_mobileFixedHeaderWrapper__3Bl3u"};